import listSensorsService from "./../shared/services/listSensorsService";

const REQUEST_LIST_SENSORS = "REQUEST_LIST_SENSORS";
const RESPONSE_LIST_SENSORS = "RESPONSE_LIST_SENSORS";
const REQUEST_LIST_SENSORS_FAILURE = "REQUEST_LIST_SENSORS_FAILURE";

const requestListSensorsAction = () => {
  return {
    type: REQUEST_LIST_SENSORS,
  };
};

const responseListSensorsAction = (data) => {
  return {
    type: RESPONSE_LIST_SENSORS,
    data,
  };
};

const requestListSensorsFailureAction = () => {
  return {
    type: REQUEST_LIST_SENSORS_FAILURE,
  };
};

const getListSensors = () => {
  return (dispatch) => {
    dispatch(requestListSensorsAction());

    listSensorsService
      .getListSensors()
      .then((result) => {
        dispatch(responseListSensorsAction(result.data));
      })
      .catch((error) => {
        dispatch(requestListSensorsFailureAction(error.response));
      });
  };
};

export { REQUEST_LIST_SENSORS, RESPONSE_LIST_SENSORS, REQUEST_LIST_SENSORS_FAILURE, getListSensors };
